export const paymentStatuses = Object.freeze({
  1: "Nieopłacone",
  2: "Nadpłata/niedopłata",
  3: "Opłacone",
});

export const getPaymentStatus = (key) => paymentStatuses[key];
